const { connect } = require('react-redux');
const { push: Push } = require('connected-react-router');
const { context } = require('app-context');
const Homepage = require('../components/Homepage');

const selectors = context.selectors.all;
const actions   = context.actions;

module.exports = connect(
    (state) => ({
        isAuthenticated: selectors.getIsAuthenticated(state)
    }), {
        onLogout: actions.auth.logout,
        push: Push
    }
)(Homepage);
